import { BaseTaxFragment } from "graphql.generated";

export interface EditableExpense {
  expenseId: string;
  unitCost: number;
}

export const jobMutateChargesInitialState = {
  productId: undefined as string | undefined,
  productName: undefined as string | undefined,
  description: undefined as string | undefined,
  amount: undefined as number | undefined,
  quantity: undefined as number | undefined,
  eventIds: [] as string[],
  taxes: [] as BaseTaxFragment[],
  expenses: [] as EditableExpense[],
  chargeId: undefined as string | undefined,
} as const;

